import { getEvents } from '@app/analytics/models/helpers';
import { TagContainer } from '@app/analytics/models/container';
import { AutocompleteSearch } from '@app/store';

/**
 * When user clics on result from autocomplete.
 *
 * The `contentType` variable describes the content searched using autocomplete (eg. Brand, Product).
 *
 *  - If `contentType` = "Brand", `contentId` = brand name
 *  - If `contentType` = "Product", `contentId` = product ID
 *  - If `contentType` = "autocomplete", `contentId` = popular | recent | suggestion product | suggestion brand
 */
const events = getEvents((action: AutocompleteSearch) => [
  {
    type: 'event',
    container: TagContainer.Analytics,
    payload: {
      event: 'searchAutocomplete',
      keyword: action.payload.query,
      contentType: action.payload.contentType,
      contentId: action.payload.contentId
    }
  }
]);

export default events;
